<template>
    <el-dialog
        title="申请注销BIGEMAP账号"
        :visible.sync="visible"
        width="600px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose">
        <div style="height: 400px;overflow: auto">
            <div class="content">
                <h2 class="center title">申请注销账号</h2>
                <div class="center info" style="text-indent: 20px;text-align: left">
                    您当前正在申请注销账号申请，为了安全起见，BIGEMAP团队会进行以下验证以保证你账号的安全
                </div>
                <div class="request">
                    <ul>
                        <li>
                            <p class="title">账号处于安全情况</p>
                            <p class="info">账号最近1个月内无异常登录等其他影响账户安全的情形</p>
                        </li>
                        <li>
                            <p class="title">账号无其它关联情况</p>
                            <p class="info">账号没有涉及任何的投诉举报或被投诉举报等相关信息</p>
                        </li>
                    </ul>
                </div>
                <div class="clear">
                    <button @click="noUsage" class="clear-btn">申请注销</button>
                </div>
                <div class="center info agree">
                    <p>申请即代表已经阅读和同意以下重要提示 <a class="tip" href="javascript:void (0)">《重要提示》</a></p>
                </div>
                <div class="main-tip">
                    <p class="title">
                        《重要提醒》
                    </p>
                    <p>
                        注销BIGEMAP帐号是不可恢复的操作，你应自行备份BIGEMAP帐号相关的信息和数据。操作之前，请确认与BIGEMAP帐号相关的所有服务均已进行妥善处理。</p>
                    <p>
                        请谨记：注销BIGEMAP帐号，你将无法再使用本BIGEMAP帐号或找回你添加或绑定的任何内容或信息（即使你使用相同的手机号码再次注册并使用BIGEMAP），包括但不限于：</p>
                    <p>（1）你将无法登录、使用本BIGEMAP帐号。你的朋友将无法通过本BIGEMAP帐号联系你。</p>
                    <p>
                        （2）你BIGEMAP帐号的个人资料和历史信息（包含昵称、头像、二维码名片、消息记录、朋友圈内容、相片、收藏等）都将无法找回。</p>
                    <p>（3）在BIGEMAP帐号注销期间，如果你的BIGEMAP帐号被他人投诉、被国家机关调查或者正处于诉讼、仲裁程序中，BIGEMAP有权自行终止你BIGEMAP帐号的注销而无需另行得到你的同意。
                        请注意，注销你的BIGEMAP帐号并不代表本BIGEMAP帐号注销前的帐号行为和相关责任得到豁免或减轻。</p>
                    <p style="font-weight: bold">
                        *申请注销后，15天内未登陆即完成BIGEMAP账号的注销。15天之内登陆，即解除注销申请*
                    </p>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
    <el-button @click="beforeClose">取 消</el-button>
  </span>
    </el-dialog>
</template>
<script>
import storage from "@/utils/storage";

export default {
    props: ['show'],
    data() {
        return {
            baseUrl: '/bbs/user/nou',
            visible: false,
        }
    },
    watch: {
        show: {
            immediate: true,
            handler: function (v) {
                this.visible = v;
            }
        }
    },
    methods: {
        beforeClose() {
            this.$emit('change', {type: 'close'});
        },
        noUsage() {
            this.$confirm('你真的要注销BIGEMAP账号吗?', '注销确认').then(() => {
                this.$bbs.post(this.baseUrl).then(() => {
                    this.$message.success('申请成功!');
                    storage.clear();
                    setTimeout(() => {
                        this.$router.push({
                            path: '/index'
                        });
                        location.reload();
                    }, 1500);
                });
            });
        }
    }
}
</script>
<style scoped lang="less">
.title {
    padding: 20px 0;
    color: #111;
}

.request {
    padding: 20px;

    ul {
        list-style-type: disc;
    }

    .title {
        font-size: 22px;
        color: #333;
        font-weight: bold;
    }
}

.info {
    color: #444;
    line-height: 20px;
}

.center {
    text-align: center;
}

.clear {
    text-align: center;

    .clear-btn {
        padding: 10px 60px;
        background: #149bd9;
        font-size: 16px;
        border: none;
        color: #fff;
    }
}

.agree {
    padding: 20px;
}

.main-tip {
    padding: 15px;

    .title {
        font-size: 24px;
    }

    p {
        text-indent: 20px;
        line-height: 20px;
        margin-top: 10px;
    }
}
</style>